<template>
    <v-card id="canvaWrapper" class="mb-4" elevation="0">
        <div class="d-flex">
            <h1 class="display-1 font-weight-light mx-4">Firme aquí</h1>
            <v-spacer></v-spacer>
            <!-- <v-icon class="d-flex align-self-center mx-2" large @click="save" color="success">mdi-content-save</v-icon> -->
            <v-icon class="d-flex align-self-center mx-2" large @click="downloadImage" color="primary">mdi-camera</v-icon>
            <v-icon class="d-flex align-self-center mx-2" large dark @click="deleteCanvas" color="red">mdi-delete</v-icon>
        </div>
        <canvas 
            :width="realWidth" 
            id="myCanvas" 
            class="" 
            @mousemove="draw" 
            @mousedown="beginDrawing" 
            @mouseup="stopDrawing"
        />
    </v-card>
</template>

<script>

export default {
    data: ()=> ({
        realWidth: 0,
        canvas: null,
        isDrawing: false,
        x: 0,
        y: 0,
    }),
    mounted() {
        var c = document.getElementById("myCanvas");
        this.canvas = c.getContext('2d');
    },
    props:{
        render: {
            type: Boolean,
            default: undefined,
        },
    },
    computed: {
        isVisible() {
            return document.getElementById('canvaWrapper') ? true : false;
        }
    },
    methods: {
        canvaWrapperWidth() {
            if(document.getElementById('canvaWrapper')){
                const BORDER = 20;
                let width = document.getElementById('canvaWrapper').offsetWidth - BORDER;
                this.realWidth = width;
            }
        },
        drawLine(x1, y1, x2, y2) {
            let ctx = this.canvas;
            ctx.beginPath();
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        },
        draw(e) {
            if(this.isDrawing) {
                this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                this.x = e.offsetX;
                this.y = e.offsetY;
            }
        },
        beginDrawing(e) {
            this.x = e.offsetX;
            this.y = e.offsetY;
            this.isDrawing = true;

            this.canvaWrapperWidth();
        },
        stopDrawing(e) {
            if (this.isDrawing) {
                this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                this.x = 0;
                this.y = 0;
                this.isDrawing = false;
            }
        },
        deleteCanvas() {
            let ctx = this.canvas;
            this.isDrawing = false;
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        },
        downloadImage() {
            let obj = {
                elementId: 'myCanvas',
                downloadName: 'myCanvas',
                scale: 3
            };

            this.$store.dispatch('util/printThis', obj);
        },
        save() {

        },
    },
    watch: {
        render() {
            this.canvaWrapperWidth();
            this.deleteCanvas();
        }
    },
}
</script>


<style scoped>
.bg {
    /* background-color: #f5f5f5; */
    border-radius: 5px;
    padding: 10px;
}
</style>